import { ResourceLoader } from "./res/ResourceLoader";
export function getResources() {
    return ResourceLoader.instance.get();
}
